module.exports = __webpack_public_path__ + "img/complete.cc68a174.svg";